"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessingView = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const process_spinner_1 = require("../../icons/process-spinner");
const styled_1 = require("./styled");
const ProcessingView = ({ active }) => (react_1.default.createElement(styled_1.OverlapWrapper, { className: "processing-overlap-wrapper" },
    react_1.default.createElement(components_core_1.LayerWrapper, { contentCentered: true }, active && (react_1.default.createElement(styled_1.ProcessingWrapper, { className: "Processing-class" },
        react_1.default.createElement(styled_1.ContentWrapper, { className: "content-wrapper" },
            react_1.default.createElement(styled_1.IconWrapper, { className: "icon-wrapper" },
                react_1.default.createElement(process_spinner_1.ProcessSpinner, null)),
            react_1.default.createElement(styled_1.TextWrapper, { className: "text-wrapper" },
                react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy100, textAlign: components_core_1.TextAlignment.center }, "Processing your submission\u2026"))))))));
exports.ProcessingView = ProcessingView;
